export default __webpack_public_path__ + "static/media/cleaning.1f96bfaf.png";